import { render } from "./LoginQuanTri.vue?vue&type=template&id=6b27eab4&scoped=true"
import script from "./LoginQuanTri.vue?vue&type=script&lang=js"
export * from "./LoginQuanTri.vue?vue&type=script&lang=js"

import "./LoginQuanTri.vue?vue&type=style&index=0&id=6b27eab4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b27eab4"]])

export default __exports__